import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubscriptions, fetchSubscriptionStatus } from 'State/Subscriptions/SubscriptionsActions';
import { useStore } from './useStore';

export const useSubscription = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useStore('user');
  const { isPlanPayment } = useStore('purchaseMode');
  const subscription = useSelector((s) => s.subscription);
  useEffect(() => {
    if (isAuthenticated && !subscription.isSuccess && !subscription.isFetching) {
      dispatch(fetchSubscriptions());
      if (isPlanPayment) {
        dispatch(fetchSubscriptionStatus());
      }
    }
  }, [dispatch, isPlanPayment, isAuthenticated, subscription]);
  return subscription;
};
